<template>
  <section class="hrv-hero hrv-hero--overlay" aria-label="Главный баннер">
    <div class="hr-container">
      <div class="hrv-hero__stage">
        <div class="hrv-hero__media" aria-hidden="true">
          <img :src="data.image" :alt="data.imageAlt || ''" />
        </div>

        <div class="hrv-hero__card">
          <p class="hrv-hero__eyebrow hrv-hero__eyebrow--accent">
            <span class="hrv-hero__eyebrow-mark" aria-hidden="true"></span>
            {{ data.eyebrow }}
          </p>
          <h1 class="hrv-hero__title">
            <span class="hrv-hero__title-lead hrv-hero__title-lead--dark">{{ data.titleLine1 }}</span>
            <span class="hrv-hero__title-brand hrv-hero__title-brand--dark">{{ data.titleBrand }}</span>
          </h1>
          <p class="hrv-hero__desc hrv-hero__desc--wrap hrv-hero__desc--dark">{{ data.description }}</p>
          <div class="hrv-hero__actions">
            <router-link
              v-for="action in data.actions"
              :key="action.label"
              class="hr-btn"
              :class="action.primary ? 'hr-btn--primary' : 'hr-btn--outline'"
              :to="action.to"
            >
              {{ action.label }}
            </router-link>
          </div>
        </div>

        <ul v-if="quickLinks && quickLinks.length" class="hrv-quick-dock" aria-label="Быстрые ссылки">
          <li v-for="item in quickLinks" :key="item.label">
            <router-link class="hrv-quick-dock__item" :to="item.to">
              <span class="hrv-quick-dock__icon">
                <HrIcon :name="item.icon" :image="item.iconImage" />
              </span>
              <span class="hrv-quick-dock__label">{{ item.label }}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import HrIcon from '../components/HrIcon.vue'

export default {
  name: 'HrHeroOverlayDock',
  components: { HrIcon },
  props: {
    data: { type: Object, required: true },
    quickLinks: { type: Array, default: () => [] },
  },
}
</script>
